import React, { useEffect, useState } from 'react'
import todo from "../image/todologo.png";
import "../App.css"

const getlocalItem=()=>{
    let lists= localStorage.getItem('lists');
   if(lists){
    return JSON.parse(localStorage.getItem('lists'));
        
   }else{
    return[];
   }
}

 const Todo = () => {
    const[inputData,setInputData]=useState("");
    const[item,setItems]=useState(getlocalItem());
    const[togglesubmit,setToggleSubmit]=useState(true);
    const [isEditItem,setIsEditItem]=useState(null);

    const addItem=()=>{
        if(!inputData){
       alert("fill data");
        }else if(inputData && !togglesubmit)
        {
            setItems(item.map((elem)=>
            {
                if(elem.id===isEditItem){
                    return{...elem,name:inputData}
                }
                return elem;
            })
            )
            setToggleSubmit(true);
        setInputData('');
        setIsEditItem(null);

        }
        else{
            const allInputData={id:new Date().getTime().toString(),name:inputData}
   setItems([...item,allInputData]);
   setInputData("");
        }
    }
    const deleteItem =(index) =>{
        const updateitems = item.filter((elem) =>{
            return index != elem.id;
        });
        setItems(updateitems)
    };
    const editItem=(id)=>{
        let newEdititem=item.find((elem)=>{
return elem.id ===id
        });
        setToggleSubmit(false);
        setInputData(newEdititem.name);
        setIsEditItem(id);

    }
    const removeAll =()=>{
        setItems([]);
    }

        useEffect(()=>{
     localStorage.setItem('lists',JSON.stringify(item))


     },[item]);
    
  return (
    <div className="main-div">
        <div className="child-div">
            <figure>
                <img src={todo} alt=""/><br/>
                <figcaption>Add Your List</figcaption>
            </figure>
            <br/>
            <div className="additems">
                <input type="text" placeholder="Add Item..." value={inputData}
                onChange={(e)=>setInputData(e.target.value)}
                />
                {
                    togglesubmit ? <i className="fa fa-plus add-btn" title="Add Item" onClick={addItem}></i>:
                    <i className="fa fa-plus add-btn" title="Update Item" onClick={addItem}></i>
                }
                
               
                
                
            </div>
            <div className="showItems">
                {
                    item.map((elem) => {
                        return(    <div className="eachItem" key={elem.id}>
                        <h3>{elem.name}</h3>
                        <div className="todo-btn">
                     <button> <span> <i className="far fa-edit add-btn" title="Edit Item" onClick={()=>editItem(elem.id)}></i></span></button>
                    <button>  <span> <i className="far fa-trash-alt add-btn" title="Delete Item" onClick={()=>deleteItem(elem.id)}></i></span> </button>
                         </div>
                    </div>)
                    })
                }
            
                <div className="showItems">
                    <button className="btn effect04" data-sm-link-text="Remove All" onClick={removeAll}><span>REMOVE LIST</span></button>
                </div>
              
            </div>
        </div>

</div>

  )
  



}



export default Todo